import { useState, useEffect } from "react";
import axios from "axios";
import LykioButton from "../common/LykioButton";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  AUTHORIZED_URL_PREFIX,
  PUBLIC_URL_PREFIX,
  NOTIFICATION_SEVERITY_SUCCESS,
  UBER_ADMIN_SETTINGS_URL,
  AxiosConfig,
} from "../../Utils/Constants";
import "./firstAdminScreen.css";
import t from "../../Utils/Translation";
import { useNavigate } from "react-router";
import { notify, pleaseRefreshError } from "../../Utils/Notificator";

const UberScreen = () => {
  const navigate = useNavigate();
  const [showRegisterOrg, setShowRegisterOrg] = useState(false);
  const [showRegisterToLykio, setShowRegisterToLykio] = useState(false);
  const [showRegisterWithMagicCode, setShowRegisterWithMagicCode] =
    useState(false);
  const [showRegisterWithAccessCode, setShowRegisterWithAccessCode] =
    useState(false);
  const [showBillingOptions, setShowBillingOptions] = useState(false);
  const [showCreateAccessCode, setShowCreateAccessCode] = useState(false);
  const [authScreensLogo, setAuthScreensLogo] = useState();
  const [lykioBackground, setLykioBackground] = useState();
  const [languages, setLanguages] = useState([]);
  const [languageCode, setLanguageCode] = useState();
  const [languageName, setLanguageName] = useState();

  useEffect(async () => {
    const { data } = await axios.get(
      `${PUBLIC_URL_PREFIX}${UBER_ADMIN_SETTINGS_URL}`,
      AxiosConfig()
    );
    console.log(data);
    data.uberSettings && setShowRegisterOrg(data.uberSettings.showRegisterOrg);
    data.uberSettings &&
      setShowRegisterToLykio(data.uberSettings.showRegisterToLykio);
    data.uberSettings &&
      setShowRegisterWithMagicCode(data.uberSettings.showRegisterWithMagicCode);
    data.uberSettings &&
      setShowRegisterWithAccessCode(
        data.uberSettings.showRegisterWithAccessCode
      );
    data.uberSettings &&
      setShowBillingOptions(data.uberSettings.showBillingOptions);
    data.uberSettings &&
      setShowCreateAccessCode(data.uberSettings.showCreateAccessCode);
	data.uberSettings &&
		setLanguages(data.uberSettings.languages);
    data.uberSettings && setAuthScreensLogo(data.uberSettings.authScreensLogo);
    data.uberSettings && setLykioBackground(data.uberSettings.lykioBackground);
  }, []);

  const uberSettingsHandler = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      // formData.append('logo', logo);
      formData.append("authScreensLogo", authScreensLogo);
      formData.append("lykioBackground", lykioBackground);
      formData.append("showRegisterOrg", showRegisterOrg);
      formData.append("showRegisterToLykio", showRegisterToLykio);
      formData.append("showRegisterWithMagicCode", showRegisterWithMagicCode);
      formData.append("showRegisterWithAccessCode", showRegisterWithAccessCode);
      formData.append("showBillingOptions", showBillingOptions);
      formData.append("showCreateAccessCode", showCreateAccessCode);
      formData.append("languageCode", languageCode);
      formData.append("languageName", languageName);

      const { data } = await axios.post(
        `${AUTHORIZED_URL_PREFIX}${UBER_ADMIN_SETTINGS_URL}`,
        formData,
        AxiosConfig("multipart/form-data")
      );
      if (data.success === true) {
        notify({
          title: `${t("You have successfully updated your Uber Lykio Settings.")}`,
          severity: NOTIFICATION_SEVERITY_SUCCESS,
          creationDate: "",
        });
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      notify(pleaseRefreshError);
    }
  };

  return (
    <div className="lykioccs-main-content">
      <div className="lykiocss-screen-center">
        <Form
          onSubmit={uberSettingsHandler}
          className="lykiocss-form lykiocss-form-border lykiocss-form-size"
        >
          <h3 className="lykiocss-center">{t("UberAdmin Management")}</h3>
          <Container>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowRegisterOrg(!showRegisterOrg);
                    }}
                    checked={showRegisterOrg}
                    type="switch"
                    id="showRegisterOrg"
                    label={t("Show Register Organisation")}
                  />
                </Form.Group>
                <br />

                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowRegisterToLykio(!showRegisterToLykio);
                    }}
                    checked={showRegisterToLykio}
                    type="switch"
                    id="showRegisterToLykio"
                    label={t("Show Register To Lykio")}
                  />
                </Form.Group>
                <br />

                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowRegisterWithMagicCode(!showRegisterWithMagicCode);
                    }}
                    checked={showRegisterWithMagicCode}
                    type="switch"
                    id="showRegisterWithMagicCode"
                    label={t("Show Register With Magic Code")}
                  />
                </Form.Group>
                <br />

                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowBillingOptions(!showBillingOptions);
                    }}
                    checked={showBillingOptions}
                    type="switch"
                    id="showBillingOptions"
                    label={t("Show Billing Options")}
                  />
                </Form.Group>
                <br />

                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowRegisterWithAccessCode(
                        !showRegisterWithAccessCode
                      );
                    }}
                    checked={showRegisterWithAccessCode}
                    type="switch"
                    id="showRegisterWithAccessCode"
                    label={t("Show Register With Access Code")}
                  />
                </Form.Group>
                <br />

                <Form.Group>
                  <Form.Check
                    onChange={() => {
                      setShowCreateAccessCode(!showCreateAccessCode);
                    }}
                    checked={showCreateAccessCode}
                    type="switch"
                    id="showCreateAccessCode"
                    label={t("Show Create Access Code")}
                  />
                </Form.Group>
                <br />
				<Form.Group controlId="formLogo" className="mb-3">
                  <Form.Label>{t("My Default Logo")}</Form.Label>
                  <Form.Control
                    filename={authScreensLogo}
                    accept="image/*"
                    type="file"
                    onChange={(e) => setAuthScreensLogo(e.target.files[0])}
                  />
                </Form.Group>

                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>{t("My Default Background")}</Form.Label>
                  <Form.Control
                    filename={lykioBackground}
                    accept="image/*"
                    type="file"
                    onChange={(e) => setLykioBackground(e.target.files[0])}
                  />
                </Form.Group>
              </Col>

              <Col>
				<Form.Label>{t('Available Languages')}</Form.Label><br/>
				<Form.Select>
					{languages.map((language) => (
					<option>
						{t(language.name)}
					</option>
					))}
				</Form.Select>

				<br/>
				<Form.Group className="mb-3" controlId="languageCode">
					<Form.Label>{t("New Language Code")}</Form.Label>
					<Form.Control type="text" placeholder={t("Enter i18n value (en, el, es etc.)")} 
					value={languageCode}
					onChange={(e) => {
						setLanguageCode(e.target.value);
					}}/>
				</Form.Group>
				<br/>
				<Form.Group className="mb-3" controlId="languageName">
					<Form.Label>{t("New Language Name")}</Form.Label>
					<Form.Control type="text" placeholder={t("Enter language name (English, Greek, Spanish etc.)")} 
					value={languageName}
					onChange={(e) => {
						setLanguageName(e.target.value);
					}}/>
				</Form.Group>
              </Col>
            </Row>
          </Container>

          <LykioButton
            variant="contained"
            type="text"
            className="float-end lykiocss-form-button"
          >
            {t("Update Settings")}
          </LykioButton>
        </Form>
      </div>
    </div>
  );
};

export default UberScreen;
